import { createEntityAdapter, EntityState } from "@magicware/redux/entities";
import { anchoreThunks, AsyncSliceState } from "@magicware/redux/thunks";
import { createSlice } from "@reduxjs/toolkit";
import {
    entityApi,
    ApiServerVersionModelDetail,
    ApiServerVersionFilter,
    ApiServerVersionModelList,
} from "../../services/api/apiServerVersions";
import { RootState } from "../types";

export interface State
    extends EntityState<ApiServerVersionModelDetail, ApiServerVersionModelList, ApiServerVersionFilter>,
        AsyncSliceState {}

const initialState: State = { async: {} };

const adapter = createEntityAdapter("apiServerVersions", entityApi, ["name"]);

const extraThunks = {};

const slice = createSlice({
    name: "apiServerVersions",
    initialState,
    reducers: adapter.getReducers(),
    extraReducers: (builder) => {
        adapter.addExtraReducers(builder);
        //addAsyncThunkReducers(builder, extraThunks.xxx);
    },
});

export const apiServerVersionThunks = anchoreThunks((state: RootState) => state.apiServerVersions, {
    ...extraThunks,
    ...adapter.thunks,
});

export const actions = slice.actions;
export const { updateDetail, clearList, removeListItems, updateListItems, setPage } = slice.actions;
export default slice.reducer;
